// State
export const state = () => ({
	loading: false,
	item: {}
})

// Actions
export const actions = {
	async gets({ commit }) {
		try {
			commit('loading', true)
			await this.$axios
				.get(`/organization-chart`)
				.then((response) => {
					commit('setItem', response.data.data)
					commit('loading', false)
				})
		} catch (error) {
			commit('loading', false)
		}
	},
	async update({ commit, dispatch }, form) {
		const data = { ...form }
		const formData = new FormData()
		for (const key in data) {
			if (key === 'content') {
				formData.append(key, JSON.stringify(data[key]));
			} else {
				formData.append(key, data[key]);
			}
		}
		try {
			commit('loading', true)
			const response = await this.$axios
				.post(`/organization-chart`, formData)
				.then((response) => {
					dispatch('gets')
					commit('loading', false)
					return true
				})
			return response
		} catch (error) {
			commit('loading', false)
		}
	},
}

// Mutations
export const mutations = {
	loading(state, type) {
		state.loading = type
	},
	setItem(state, data) {
		state.item = data
	}
}

// Getters
export const getters = {}